import React from "react";
import { Route, Routes } from "react-router-dom";
import { routes } from "./routes";
import MainLayout from "./layout/MainLayout";
import { Theme } from "@radix-ui/themes";
import Login from "./views/Login/Login";

const Content = () => {
  return (
    <Theme panelBackground="solid" radius="none">
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="*"
          name="Home"
          element={
            <>
              <Routes>
                {routes.map((urls, i) => (
                  <Route
                    key={i}
                    path={urls.path}
                    element={<MainLayout>{urls.component}</MainLayout>}
                  />
                ))}
              </Routes>
            </>
          }
        />
        {/* {routes.map((urls, i) => (
          <Route
            key={i}
            path={urls.path}
            element={<MainLayout>{urls.component}</MainLayout>}
          />
        ))} */}
      </Routes>
    </Theme>
  );
};

export default Content;
